module.exports = __webpack_public_path__ + "img/elemental.27c85067.jpg";